import { Typography, Stack, styled } from "@mui/material";

import { useTransactionStats } from "@/hooks/use-transaction-stats";
import { TransactionsSummary } from "../data";
import CustomSearchInput from "@/components/custom/custom-search-input";
import CustomSelectInput from "@/components/custom/custom-select-input";
import { useSearchParams } from "react-router-dom";
import { useTransactions } from "@/hooks/use-transactions";
import { DataTable } from "@/components/custom/data-table";
import CustomPagination from "@/components/custom/custom-pagination";
import { useMemo } from "react";
import CustomSimpleCard from "@/components/custom/custom-simple-card";
import { TransactionColumns } from "@/components/transactions/transaction-columns";

const SectionRoot = styled("section")(({ theme }) => ({
  margin: theme.spacing(2),
}));

const Card = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: "16px 20px",
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const Transactions = () => {
  const [searchParams] = useSearchParams();
  const searchValue = searchParams.get("search") || "";

  const currentPage = Number(searchParams.get("page") || 0);
  const pageSize = Number(searchParams.get("size") || 10);
  const status = searchParams.get("status");

  const queryParams = {
    page: currentPage,
    size: pageSize,
    status: status ? status : undefined,
    search: searchValue,
  };

  const {
    data: transactions,
    isLoading: isTransactionsLoading,
    isError,
  } = useTransactions(true, queryParams);

  const columns = useMemo(() => TransactionColumns, []);

  const { stats, isLoading } = useTransactionStats();

  return (
    <SectionRoot>
      <Stack spacing={2}>
        <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
          {TransactionsSummary.map(({ title, objKeyRepr, icon }, idx) => (
            <CustomSimpleCard
              key={`${objKeyRepr}-${idx}`}
              title={title}
              icon={icon}
              isLoading={isLoading}
            >
              <Typography variant="h6">{stats?.[objKeyRepr] ?? 0}</Typography>
            </CustomSimpleCard>
          ))}
        </Stack>

        <Card>
          <Stack direction="row" spacing={3} flexWrap="wrap">
            <CustomSearchInput
              paramKey="search"
              placeholder="Search transactions..."
            />
            <CustomSelectInput
              paramKey="status"
              label="Status"
              placeholder="All Status"
              options={[
                { label: "Successful", value: "SUCCESSFUL" },
                { label: "Pending", value: "PENDING" },
                { label: "Failed", value: "FAILED" },
              ]}
            />
          </Stack>

          <DataTable
            data={transactions?.data ?? []}
            columns={columns}
            isLoading={isTransactionsLoading}
            isError={isError}
          />

          <CustomPagination
            total={transactions?.total_count ?? 0}
            perPageOptions={[5, 10, 20, 50, 100]}
          />
        </Card>
      </Stack>
    </SectionRoot>
  );
};
